import { Stack } from '@mui/material';
import type { StackProps } from '@mui/material';

import type { AppName } from '@tbd/lift-portal-shared-config';
import { AppTitle } from '@tbd/lift-ui/components/AppTitle';
import { LGHLogo } from '@tbd/lift-ui/components/LGHLogo';
import { VerticalDivider } from '@tbd/lift-ui/components/VerticalDivider';
import { WhiteOutlinedLGHLogo } from '@tbd/lift-ui/components/WhiteOutlinedLGHLogo';

export function LogoTitleLockup({
  sx,
  textColor,
  logoVariant,
  appName,
}: {
  sx?: StackProps;
  textColor: 'black' | 'white';
  logoVariant: 'multi-colored' | 'outlined-white';
  appName: AppName;
}) {
  const logo =
    logoVariant === 'multi-colored' ? <LGHLogo /> : <WhiteOutlinedLGHLogo />;
  const width = logoVariant === 'multi-colored' ? 1 : 2;
  return (
    <Stack
      direction={'row'}
      {...sx}
      sx={[
        {
          alignItems: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack
        sx={{
          justifyContent: 'center',
        }}
      >
        {logo}
      </Stack>
      <Stack
        sx={{
          justifyContent: 'center',
          padding: { xs: 1, md: 1.5 },
        }}
      >
        <VerticalDivider width={width} color={textColor} />
      </Stack>
      <Stack>
        <AppTitle appName={appName} color={textColor} />
      </Stack>
    </Stack>
  );
}
